module.exports = "/circle_plus_primary-f9f04c81b5cf62a92b12815bb18b959f.svg";